import script from "./sf-virtual-table-data-row.vue?vue&type=script&setup=true&lang=js"
export * from "./sf-virtual-table-data-row.vue?vue&type=script&setup=true&lang=js"

import "./sf-virtual-table-data-row.vue?vue&type=style&index=0&id=f28dbae6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f28dbae6"]])

export default __exports__